export default "__VITE_ASSET__2a2670e5__"